/** In-app route for subscription message appearance action analytics (insights REST API). */
export function subscriptionMessageAppearanceActionAnalyticsPath(subscriptionId: string): string {
  return `/subscription/${subscriptionId}/message-appearance-action-analytics`
}
